(() => {
  const sections = [...document.querySelectorAll('[data-exp-step]')];
  const links = [...document.querySelectorAll('.exp-chapters a')];
  const rail = document.querySelector('.exp-chapters-inner');
  const dialog = document.getElementById('exp-screen-dialog');
  const dialogImage = dialog?.querySelector('img');
  const dialogCaption = dialog?.querySelector('figcaption');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!reduceMotion.matches && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('exp-motion');
    const reveal = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          reveal.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    document.querySelectorAll('.exp-reveal').forEach(element => reveal.observe(element));
  }

  let scheduled = false;
  function updateJourney() {
    scheduled = false;
    if (!sections.length || !rail) return;
    const focus = window.innerHeight * 0.42;
    let current = sections[0];
    for (const section of sections) {
      if (section.getBoundingClientRect().top <= focus) current = section;
    }
    links.forEach(link => {
      if (link.hash === '#' + current.id) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    const start = sections[0].offsetTop;
    const end = sections[sections.length - 1].offsetTop +
      sections[sections.length - 1].offsetHeight - window.innerHeight * 0.5;
    const fraction = Math.max(0, Math.min(1, (window.scrollY - start) / Math.max(1, end - start)));
    rail.style.setProperty('--exp-progress', String(fraction));
  }
  function scheduleJourney() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateJourney);
  }
  window.addEventListener('scroll', scheduleJourney, { passive: true });
  window.addEventListener('resize', scheduleJourney, { passive: true });
  updateJourney();

  if (dialog && dialogImage && dialogCaption) {
    document.querySelectorAll('[data-screen]').forEach(button => {
      button.addEventListener('click', () => {
        dialogImage.src = button.dataset.screen;
        dialogImage.alt = button.dataset.caption || 'Anywhere Healing app screen';
        dialogCaption.textContent = button.dataset.caption || '';
        dialog.showModal();
      });
    });
    dialog.querySelector('.exp-dialog-close')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
  }
})();
